export default __webpack_public_path__ + "static/media/jpeg.22801b5b.svg";